import {definitions} from './operations/index.js';
export default superclass => class extends superclass  {

    onOperation([operation, ...args]) {
        let tokens = operation.split(" ").filter(x => x != "" && x !== " ");
        let name = tokens[0];
        let _args = tokens.slice(1).map(x => parseFloat(x));
        let fn = definitions[name];
        if (fn) {
            fn(this, ... _args);
        }
    }
}
